export default __webpack_public_path__ + "static/media/img_6.258bdac1.jpg";